import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/SignupCompletedPage.css';
import { useAuth } from '../context/AuthContext';
import { getUserProfile, getUserIconPath } from '../services/userService';

const SignupCompletedPage: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [fornavn, setFornavn] = useState<string>('');
  const [userIconPath, setUserIconPath] = useState<string>('/images/User_icon.png');

  useEffect(() => {
    const fetchUserData = async () => {
      if (!currentUser) {
        navigate('/login');
        return;
      }

      try {
        const profile = await getUserProfile(currentUser.uid);
        if (profile) {
          setFornavn(profile.fornavn);
          setUserIconPath(getUserIconPath(profile.userIcon));
        }
      } catch (error) {
        console.error('Error fetching user profile:', error);
      }
    };

    fetchUserData();
  }, [currentUser, navigate]);

  const handleGetStarted = () => {
    // Navigate to main page experience
    navigate('/main');
  };

  return (
    <div className="signup-completed-page">
      {/* Background Image */}
      <div className="background-image"></div>

      {/* User Avatar - 150x150px */}
      <div className="avatar-logo-container">
        <img src={userIconPath} alt="User Avatar" className="avatar-logo-image" />
      </div>

      {/* Welcome Message */}
      <div className="welcome-container">
        <h2 className="welcome-message">
          Hej {fornavn} <span className="wave-emoji">👋</span>
        </h2>
        <p className="membership-text">Du er nu medlem af Wiin! Let's play.</p>
      </div>

      {/* Start Button */}
      <div className="start-button-container">
        <button className="start-button" onClick={handleGetStarted}>
          Kom i gang! <span className="arrow-icon">→</span>
        </button>
      </div>

      {/* Progress Indicator */}
      <div className="progress-indicator">
        <img src="/images/onboarding_3.png" alt="Step 3 of 3" className="progress-image" />
      </div>
    </div>
  );
};

export default SignupCompletedPage; 